import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calculator, Ruler, Settings, HeadphonesIcon } from 'lucide-react';
import { Button } from '../ui/button';
import { engineeringOffice } from '../../data/mock';

const EngineeringPage = () => {
  const icons = [Calculator, Ruler, Settings, HeadphonesIcon];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#242726]">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="caption text-[#c4291c] mb-4 block">Expertise</span>
              <h1 className="heading-1 text-white mb-6">
                {engineeringOffice.title}
              </h1>
              <p className="body-large text-white/70 mb-6">
                {engineeringOffice.subtitle}
              </p>
              <p className="body-medium text-white/60">
                {engineeringOffice.description}
              </p>
            </div>
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src={engineeringOffice.image}
                  alt="Bureau d'études PREBATI"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="section-padding bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="caption text-[#c4291c] mb-4 block">Services</span>
            <h2 className="heading-1 text-white mb-6">
              Notre accompagnement technique
            </h2>
            <p className="body-large text-white/60 max-w-2xl mx-auto">
              De la conception à la réalisation, notre bureau d'études vous accompagne à chaque étape de votre projet.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {engineeringOffice.services.map((service, index) => {
              const Icon = icons[index];
              return (
                <div
                  key={index}
                  className="bg-[#2a2d2c] rounded-2xl p-8 border border-white/10 card-hover"
                >
                  <div className="w-14 h-14 rounded-2xl bg-[#c4291c]/10 flex items-center justify-center mb-6">
                    <Icon className="w-7 h-7 text-[#c4291c]" />
                  </div>
                  <h3 className="heading-3 text-white mb-4">{service.title}</h3>
                  <p className="text-white/60 body-medium">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section-padding bg-[#242726]">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="caption text-[#c4291c] mb-4 block">Méthodologie</span>
            <h2 className="heading-2 text-white mb-6">
              Comment nous travaillons avec vous
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: '01', title: 'Étude', description: 'Analyse de vos plans et besoins spécifiques' },
              { step: '02', title: 'Calculs', description: 'Dimensionnement et optimisation des planchers' },
              { step: '03', title: 'Plans', description: 'Plans de pose et documentation technique' },
              { step: '04', title: 'Suivi', description: 'Accompagnement jusqu\'au chantier' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="text-5xl font-bold text-[#c4291c]/20 mb-4">{item.step}</div>
                <h3 className="text-white font-semibold text-lg mb-2">{item.title}</h3>
                <p className="text-white/60 body-small">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#1a1c1b] border-t border-white/10">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div>
              <h3 className="heading-3 text-white mb-2">
                Un projet à étudier ?
              </h3>
              <p className="text-white/60 body-medium">
                Notre bureau d'études est à votre service.
              </p>
            </div>
            <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer">
              <Button className="btn-primary">
                Demander une étude
                <ArrowRight className="w-4 h-4" />
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EngineeringPage;
